<template>
    <span>{{ CraftFinishNum }}</span>
</template>

<script>
    export default {
        name: "CraftNum",
        props: {
            order: Object,
            craftType:Number,
        },
        computed: {
            CraftFinishNum() {
                for (let i = 0; i < this.order.craftrecord_set.length; i++) {
                    const craft = this.order.craftrecord_set[i]
                    if (parseInt(craft.craft) === this.craftType) {
                        return craft.finish_num
                    }
                }
                return ''
            }
        },
    }
</script>

<style scoped>

</style>